import { Outlet } from "react-router";
import { AdminNav } from "@/components/admin/AdminNav";
import { AppShell } from "@/components/layout/AppShell";

/** 관리자 골격 , 상단 막대(AppShell) + 왼쪽 메뉴 + 본문. 표가 넓어 산정 화면과 같은 폭(max-w-app)을 쓴다 */
export function AdminLayout() {
  return (
    <AppShell>
      <div className="admin-grid">
        <div className="admin-nav-scroll">
          <AdminNav />
        </div>
        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </AppShell>
  );
}
